import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

/** Placeholder shape shown while content loads. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
